import useWindowSize from '@/hooks/useWindowSize';
import { ScrollMenu } from 'react-horizontal-scrolling-menu';
import 'react-horizontal-scrolling-menu/dist/styles.css';
import { LeftArrow, RightArrow } from '../NewsArrows';
import { NewsItem, INewsItem } from '../NewsItem';
import s from './style.module.scss';

interface IProps {
  data: INewsItem[];
}

export const NewsList = ({ data }: IProps): JSX.Element => {
  const { mobileScreen } = useWindowSize();

  return (
    <div className={s.lists}>
      <ScrollMenu
        LeftArrow={!mobileScreen && <LeftArrow hidden={data.length <= 3} />}
        RightArrow={!mobileScreen && <RightArrow hidden={data.length <= 3} />}
        scrollContainerClassName={s.menu_scroll}
        itemClassName={s.menu}
      >
        {data.map(item => {
          return <NewsItem key={item.id} data={item} />;
        })}
      </ScrollMenu>
    </div>
  );
};
